export const Two = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23 25H17V23.5795C17 22.5862 17.5292 21.6872 18.3482 21.2891L21.6868 19.6661C22.4845 19.2783 23 18.4026 23 17.4351C23 16.0902 22.0188 15 20.8084 15H19.25C18.2703 15 17.4369 15.6957 17.128 16.6667"
      stroke="#3D3D3D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 20C3 24.5087 4.79107 28.8327 7.97918 32.0208C11.1673 35.2089 15.4913 37 20 37C24.5087 37 28.8327 35.2089 32.0208 32.0208C35.2089 28.8327 37 24.5087 37 20C37 15.4913 35.2089 11.1673 32.0208 7.97918C28.8327 4.79107 24.5087 3 20 3C15.4913 3 11.1673 4.79107 7.97918 7.97918C4.79107 11.1673 3 15.4913 3 20Z"
      stroke="#F0F4F7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
